import SkillCard from "./Skillcard";

const skillItem = [
  {
    imgSrc: '/images/figma.svg',
    label: 'Figma',
    desc: 'Design tool'
  },
  {
    imgSrc: '/images/javascript.svg',
    label: 'JavaScript',
    desc: 'Interaction'
  },
  {
    imgSrc: '/images/typescript.svg',
    label: 'TypeScript',
    desc: 'Interaction'
  },
  {
    imgSrc: '/images/react.svg',
    label: 'React',
    desc: 'Framework'
  },
  {
    imgSrc: '/images/nextjs.svg',
    label: 'Next.js',
    desc: 'Framework'
  },
  {
    imgSrc: '/images/nodejs.svg',
    label: 'NodeJS',
    desc: 'Web Server'
  },
  {
    imgSrc: '/images/expressjs.svg',
    label: 'ExpressJS',
    desc: 'Node Framework'
  },
  {
    imgSrc: '/images/mongodb.svg',
    label: 'MongoDB',
    desc: 'Database'
  },
  {
    imgSrc: '/images/python1.svg',
    label: 'Python',
    desc: 'Programming Language'
  },
  {
    imgSrc: '/images/aws1.svg',
    label: 'AWS',
    desc: 'Cloud Platform'
  },
  {
    imgSrc: '/images/git.svg',
    label: 'Git',
    desc: 'Version Control'
  },
  {
    imgSrc: '/images/tailwindcss.svg',
    label: 'TailwindCSS',
    desc: 'User Interface'
  }
];



const Skill = () => {
  return (
    <section id="skill" className="section">
<div className="container">
           <h2 className="headline-2">Essential Tools I use</h2>
           <p className="text-zinc-400 mt-3 mb-8 max-w-[50ch]">
         Discover the powerful tools and technologies I use to create exceptional, high-performing websites & applications.
        </p>
        <div className="grid gap-3 grid-cols-[repeat(auto-fill,_minmax(250px,_1fr))] ">
          {
            skillItem.map(({ imgSrc, label, desc }, key) => (
              <SkillCard
                key={key}
                imgSrc={imgSrc}
                label={label}
                desc={desc}
                classes=""
              />
            ))
          }
        </div>
        </div>
        </section>

    
  )
}

export default Skill